export default "__VITE_ASSET__SkcGcx4H__"